
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from "react";
import VirtualGamesSportList from "../../components/virtualGamesSportList";

class VirtualGames extends Component {
    constructor (props) {
        super(props);
        this.state = {
            provider: "Betconstruct"
        };
        this.setProvider = this.setProvider.bind(this);
        this.scroll = this.scroll.bind(this);
    }

    scroll (scrollSize) {
        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            this.delta = this.delta || iterator;
            this.delta += iterator;
            this.scrollVirtualGames.scrollTop += (scrollSize + this.delta);
        };
    }

    setProvider (provider) {
        return () => this.setState({provider});
    }

    render () {
        return (<div className="virtual-games-wrapper" ref={(el) => this.scrollVirtualGames = el}>
            <VirtualGamesSportList setProvider={this.setProvider} selectedProvider={this.state.provider} key={this.state.provider}/>
            <div className="scroll-b-view-w">
                <div className="single-s-b top-v" onClick={this.scroll(-200)}/>
                <div className="single-s-b bot-v" onClick={this.scroll(200)}/>
            </div>
        </div>);
    }
}

export default VirtualGames;